import { Pipe } from '@angular/core';
var MinPipe = (function () {
    function MinPipe() {
    }
    MinPipe.prototype.transform = function (arr) {
        return Array.isArray(arr)
            ? Math.min.apply(Math, arr) : arr;
    };
    MinPipe.decorators = [
        { type: Pipe, args: [{ name: 'min' },] },
    ];
    /** @nocollapse */
    MinPipe.ctorParameters = function () { return []; };
    return MinPipe;
}());
export { MinPipe };
//# sourceMappingURL=min.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/min.js
// module id = 262
// module chunks = 4